import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref } from 'vue'
import { WPasswordRecovery } from '@/widgets/WPasswordRecovery'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const landingLink = ref<string>()

onMounted(() => {
  landingLink.value = window.origin
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(WPasswordRecovery)))
}
}

})